import { useMutation, useQueryClient } from 'libs/query'
import { useNavigate, useParams } from 'libs/router'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { routes } from 'config/routes'
import { queryKeys } from 'config/queryKeys'

export const useEditRentalMutation = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()

	const { mutate: editRental, isPending: editRentalLoading } = useMutation({
		mutationFn: (data) => {
			return axiosPrivate.patch(apiRoutes.rental(params.id!), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.rentals.all })
			useToast({ type: 'success', message: t('Rental updated') })()

			navigate(routes.rentalIndex)
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editRental,
		editRentalLoading
	}
}
